/** Data local de hoje no formato YYYY-MM-DD */
export function ymdLocalHoje() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Normaliza valor de data da visita para YYYY-MM-DD ou null.
 * @param {string|Date|number|null|undefined} val
 */
export function extrairYmdDataVisita(val) {
  if (val == null || val === "") return null;
  if (typeof val === "string") {
    const s = val.trim().slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  }
  const d = val instanceof Date ? val : new Date(val);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Data fim efetiva: fim explícito ou início (visita diária). */
export function dataVisitaFimEfetiva(dataVisita, dataVisitaFim) {
  const fim = extrairYmdDataVisita(dataVisitaFim);
  const inicio = extrairYmdDataVisita(dataVisita);
  if (fim && inicio && fim > inicio) return fim;
  return inicio;
}

/** true quando há intervalo com mais de um dia civil. */
export function ehVisitaPorPeriodo(dataVisita, dataVisitaFim) {
  const inicio = extrairYmdDataVisita(dataVisita);
  const fim = extrairYmdDataVisita(dataVisitaFim);
  return !!(inicio && fim && fim > inicio);
}

/** true se o último dia do agendamento já passou em relação a hoje */
export function isDataVisitaEstritamentePassada(dataVisita, dataVisitaFim) {
  const ymd = dataVisitaFimEfetiva(dataVisita, dataVisitaFim);
  if (!ymd) return false;
  return ymd < ymdLocalHoje();
}

/** true se o dia civil informado está dentro do intervalo da visita (inclusive). */
export function visitaIncluiDia(dataVisita, dataVisitaFim, diaYmd) {
  const dia = extrairYmdDataVisita(diaYmd);
  const inicio = extrairYmdDataVisita(dataVisita);
  if (!dia || !inicio) return false;
  const fim = dataVisitaFimEfetiva(dataVisita, dataVisitaFim);
  return inicio <= dia && dia <= fim;
}

/**
 * Lista YYYY-MM-DD de início a fim (inclusive), no fuso local.
 * @returns {string[]}
 */
export function listarYmdIntervaloVisita(dataVisita, dataVisitaFim) {
  const inicio = extrairYmdDataVisita(dataVisita);
  const fim = dataVisitaFimEfetiva(dataVisita, dataVisitaFim);
  if (!inicio || !fim || fim < inicio) return inicio ? [inicio] : [];
  const out = [];
  const parts = inicio.split("-").map((x) => parseInt(x, 10));
  const cur = new Date(parts[0], parts[1] - 1, parts[2]);
  const endParts = fim.split("-").map((x) => parseInt(x, 10));
  const end = new Date(endParts[0], endParts[1] - 1, endParts[2]);
  while (cur <= end) {
    out.push(extrairYmdDataVisita(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return out;
}

/**
 * Exibe a data da visita em pt-BR (DD/MM/AAAA).
 * Usa o dia civil YYYY-MM-DD quando a string começa assim, evitando dia “errado” por UTC.
 * @param {string|Date|number|null|undefined} val
 * @returns {string} Texto formatado ou string vazia se não houver data.
 */
export function formatarDataVisitaPtBr(val) {
  const ymd = extrairYmdDataVisita(val);
  if (!ymd) return "";
  const parts = ymd.split("-").map((x) => parseInt(x, 10));
  const y = parts[0];
  const m = parts[1];
  const day = parts[2];
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(day)) return "";
  return new Date(y, m - 1, day).toLocaleDateString("pt-BR");
}

/** Ex.: 10/06/2026 ou 10/06/2026 – 12/06/2026 */
export function formatarPeriodoVisitaPtBr(dataVisita, dataVisitaFim) {
  const ini = formatarDataVisitaPtBr(dataVisita);
  if (!ini) return "";
  if (!ehVisitaPorPeriodo(dataVisita, dataVisitaFim)) return ini;
  const fim = formatarDataVisitaPtBr(dataVisitaFim);
  return fim ? `${ini} – ${fim}` : ini;
}

/**
 * Expande item da agenda em uma linha por dia do período (calendário mensal).
 * @param {Record<string, unknown>} item
 * @returns {Record<string, unknown>[]}
 */
export function expandirItemAgendaPorDias(item) {
  if (!item || typeof item !== "object") return [];
  const inicio = item.dataVisita ?? item.data_visita;
  const fim = item.dataVisitaFim ?? item.data_visita_fim;
  const dias = listarYmdIntervaloVisita(inicio, fim);
  if (dias.length <= 1) {
    const ymd = dias[0] ?? extrairYmdDataVisita(inicio);
    return [{ ...item, agendaDiaYmd: ymd }];
  }
  const baseKey = item.agendaItemKey ?? `${item.id ?? ""}_${item.visitanteIndex ?? item.visitante_index ?? 0}`;
  return dias.map((ymd) => ({
    ...item,
    agendaDiaYmd: ymd,
    agendaItemKey: `${baseKey}@${ymd}`,
  }));
}
